import { render, staticRenderFns } from "./orderDetailJoin.vue?vue&type=template&id=2ac3840b&scoped=true&"
import script from "./orderDetailJoin.vue?vue&type=script&lang=js&"
export * from "./orderDetailJoin.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailJoin.vue?vue&type=style&index=0&id=2ac3840b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac3840b",
  null
  
)

export default component.exports